import React, { createContext, useState, useEffect } from 'react';

// Context holds currency and workspace (ws) ID
export const SessionContext = createContext({
  session: { currency: 'eur', ws: null },
  setSession: () => {}
});

export function SessionProvider({ children }) {
  // Initialize from sessionStorage if available, with JSON parse safety
  const [session, setSession] = useState(() => {
    const stored = sessionStorage.getItem('campSession');
    if (stored) {
      try {
        return JSON.parse(stored);
      } catch (err) {
        console.warn('Failed parsing sessionStorage, resetting:', err);
        sessionStorage.removeItem('campSession');
      }
    }
    return { currency: 'eur', ws: null };
  });

  // Persist session state to sessionStorage on every change
  useEffect(() => {
    try {
      sessionStorage.setItem('campSession', JSON.stringify(session));
    } catch (err) {
      console.error('Failed writing sessionStorage:', err);
    }
  }, [session]);

  // On mount, extract /ws-<number> from URL and store in context
  useEffect(() => {
    const path = window.location.pathname;
    const match = path.match(/\/ws-(\d+)(?:\/|$)/);
    if (match) {
      const wsValue = match[1];
      setSession(prev => {
        if (prev.ws !== wsValue) {
          return { ...prev, ws: wsValue };
        }
        return prev;
      });
    }
  }, []);

  return (
    <SessionContext.Provider value={{ session, setSession }}>
      {children}
    </SessionContext.Provider>
  );
}
